<div class="dialog-header">
    <div class="dialog-header__content">
        <span class="dialog-header__title">{{ title }}</span>
        <button *ngIf="showCloseInHeader" mat-dialog-close mat-icon-button class="dialog-header__close-btn">
            <mat-icon size="24px">close</mat-icon>
        </button>
    </div>
    <mat-divider></mat-divider>
</div>

<mat-dialog-content class="dialog-body">
    <span class="dialog-body__text">{{ description }}</span>
</mat-dialog-content>

<div mat-dialog-actions align="end" class="dialog-footer">
    <button mat-raised-button mat-dialog-close>{{ cancelButtonText }}</button>
    <button mat-raised-button color="primary" (click)="onConfirm()">{{ confirmButtonText }}</button>
</div>
